import * as Yup from 'yup';

// Helper functions for formatting and cleaning input
export const formatWithCommas = (value) => {
  if (!value) return ''; // Handle empty input

  // Remove any non-digit characters
  const numStr = value.toString().replace(/[^0-9]/g, '');

  // Format with commas
  return Number(numStr).toLocaleString('en-US');
};

export const validationSchema = (item) => {
  const isCreate = !item?.id;
  const isRequired = true;

  let schema = Yup.object();
  schema = schema.shape({
    plateField: Yup.object()
      .nullable()
      .when([], {
        is: () => isCreate,
        then: (schema) => schema.required('Vui lòng chọn biển số'),
        otherwise: (schema) => schema.nullable(),
      }),
    });
  schema = schema.shape({
    odo: Yup.number()
      .transform((value, originalValue) => {
        if (typeof originalValue === 'string') {
          return parseFloat(originalValue.replace(/,/g, ''));
        }
        return value;
      })
      .min(1, 'Số km phải lớn hơn 1')
      .when([], {
        is: () => isRequired,
        then: (schema) => schema.required('Vui lòng nhập ODO'),
        otherwise: (schema) => schema.nullable(),
      }),
    });
  schema = schema.shape({
    created: Yup.string()
      .nullable()
      .when([], {
        is: () => isCreate,
        then: (schema) => schema.required('Ngày tạo phải có'),
        otherwise: (schema) => schema.nullable(),
      }),
    });
  return schema;
};

export const handleSubmitted = async (
  values,
  item,
  apiCreate,
  apiUpdate,
  apiRemove,
) => {
  if (!values.id) {
    await apiCreate(values);
  } else {
    if (values.isVerified) {
      await apiRemove(values);
    } else {
      await apiUpdate(values);
    }
  }
};

export const initialValues = (formik, item) => {
  if(!formik) return;

  let myId = 0;
  if (item != null && (Object.keys(item).length > 0 || item.constructor !== Object)) {
    myId = item.id;
  }

  if(0 < myId){
    formik.setFieldValue('id', myId);
  }else{
    formik.setFieldValue('odo', null);
    formik.setFieldValue('created', Date.now());
  }
};